import { FunctionComponent, ReactElement } from 'react'

import styled from 'styled-components'

import { useGetArtistBalanceStatsQuery } from 'src/Redux/artistBalanceStatsApi'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { usePageViewEvent } from 'src/Hooks/Analytics/usePageViewEvent'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'

import { BalanceSubscriptionInfo } from './components/BalanceSubscriptionInfo/BalanceSubscriptionInfo'
import { BalanceStats } from './components/BalanceStats'
import { BalanceDetails } from './components/BalanceDetails'

/**
 * Balance page. Artist side.
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    gap: 16px;
  }
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ArtistBalancePage: FunctionComponent = (): ReactElement => {
  const { data: artistBalanceStats, isFetching: isBalanceStatsLoading } =
    useGetArtistBalanceStatsQuery(null, {
      refetchOnMountOrArgChange: true,
    })

  usePageViewEvent(pageInfo.balance)

  return (
    <Container>
      <SubContainer>
        <BalanceSubscriptionInfo />
        <BalanceStats
          isLoading={isBalanceStatsLoading}
          balance={artistBalanceStats?.currentBalance}
          used={artistBalanceStats?.totalUsed}
          paid={artistBalanceStats?.totalPaid}
        />
      </SubContainer>
      <BalanceDetails />
    </Container>
  )
}
